import React, { useState, useEffect, useMemo } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Autocomplete, TextField, Box, Button } from "@mui/material";
import { BankingSyndicate, Organization, useDealContext } from "@/contexts/DealContext";
import { useParams } from "react-router";
import OrganizationMatcher from "./OrganizationMatcher";

type BankingSyndicateReviewProps = {
  syndicates: BankingSyndicate[];
  organizations: Organization[];
  onChange: (updatedSyndicates: BankingSyndicate[]) => void;
};

const BankingSyndicateReview: React.FC<BankingSyndicateReviewProps> = ({
  syndicates,
  organizations,
  onChange,
}) => {
  // État local des syndicates*
  const { loanId } = useParams();
  const [rows, setRows] = useState<BankingSyndicate[]>(syndicates);
  const { deal } = useDealContext();
  const currentLoan = deal.loans.find((loan) => loan.id === loanId);
  // Déclenche onChange à chaque modification
  useEffect(() => {
    onChange(rows);
  }, [rows]);


  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      {/* <DataGrid
        rows={rows.map((row, index) => ({ id: index, ...row }))}
        columns={columns}
        disableRowSelectionOnClick
        hideFooter
        autoHeight
        processRowUpdate={(newRow: { id: number; commitment: number }) => {
          const updatedRow: BankingSyndicate = {
            ...rows[newRow.id],
            commitment: Number(newRow.commitment),
          };
          setRows((prev) => prev.map((row, index) => (index === newRow.id ? updatedRow : row)));
          return { ...newRow };
        }}
      /> */}
      { syndicates.map((s) =>
        <OrganizationMatcher 
          key={s.name} 
          bank={s} 
          allOrganizations={organizations} 
          onValidate={(org) => {
            const updatedSyndicates = rows.map((syndicate) => {
              if (syndicate.name === s.name) {
                return {
                  ...syndicate,
                  organization: org.organization,
                  commitment: org.commitment || 0,
                  matched_organisations: s.matched_organisations,
                  registration_number: syndicate.registration_number,
                };
              }
              return syndicate;
            });
            setRows(updatedSyndicates);
          }} />
      )}
      <Button
        onClick={() =>
          setRows((rows) => [
            ...rows,
            {
              id: rows.length,
              name: "", // Add the required name property
              organization: undefined,
              commitment: 0,
              matched_organisations: [],
              registration_number: "",
            },
          ])
        }
      >
        Add lender commitment
      </Button>
    </Box>
  );
};

export default BankingSyndicateReview;
